<template>
  <div class="row p-3 mt-5 m-1">
    <div class="col-12 col-md-4">
      <h1 class="pt-3"><span class="animation1">Explore.</span> <span class="animation2">Adjust.</span> <span class="animation3">Compare.</span> <span class="animation4">Share.</span></h1>
      <p class="lead pt-3">Pharmerit uses the latest technologies to deliver powerful interactive visualizations of complex simulations and health economics analyses that are
        user-friendly, easy-to-access, and adaptable for any situation.
      </p>
      <div class="card cardShadow p-2 mb-5 pCard slide-top" style="margin-top:75px;">
        <div class="card-body">
          <h2 class="card-title">Early Switch &amp; Discharge Opportunities <br>in the EU for MRSA cSSTI</h2>
          <p class="lead pb-3">Explore results from study to evaluate opportunities for early switch from intravenous (IV) to oral antibiotics, early discharge from hospital and implications in hospitalised patients with complicated skin and soft tissue infections caused by meticillin-resistent staphylococcus aureus.</p>
          <a href="https://apps.pharmerit.com/mrsa/" class="btn btn-primary" style="margin-right:10px">View online</a> or <b-button style="margin-left:-5px;" variant="link" href="https://apps.pharmerit.com/mrsa/">Download HTML</b-button>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card cardShadow p-2 pb-3 mb-5 pCard animation3">
        <div class="card-body">
          <h2 class="card-title">Interactive Network Meta-Analysis</h2>
          <p  class="lead pb-3">Perform a custom network neta-analysis of studies examining the relative efficacy of nine HIV-1 drugs. Exclude treatments or specific study arms and view results.</p>
          <a class="btn btn-primary" href="http://rapps.pharmerit.com/16198/">View demo</a>
        </div>
      </div>
      <div class="card cardShadow mt-4 p-2 pb-3 mb-5 pCard animation1">
        <div class="card-body">
          <h2 class="card-title">
            QTWiST Benchmarking Tool
            <sup>(beta)</sup>
          </h2>
          <p  class="lead pb-3">Interpret and contextualize your Q-TWiST results against published literature Q-TWiST values.</p>
          <a class="btn btn-primary" href="https://apps.pharmerit.com/qtwist/">View online</a>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card cardShadow p-2 mb-4 pCard slide-left1">
        <div class="card-body">
          <h3 class="card-title">QTWiST IPad App</h3>
          <p class="card-text">Review a summary of 45 articles published on Q-TWiST assessments of cancer treatments with a total of 69 Q-TWiST comparisons across 10 cancers.</p>
          <a href="https://itunes.apple.com/us/app/q-twist/id999211258" class="btn btn-primary">Download from iTunes</a>
        </div>
      </div>
      <div class="card cardShadow p-2 mb-4 pCard slide-left2">
        <div class="card-body">
          <h3 class="card-title">User-Friendly Cost-Effectiveness Models</h3>
          <p class="card-text">Easily adjust inputs, compare results, and share with key audiences.</p>
          <a class="btn btn-primary" href="http://apps.pharmerit.com/cea/"  style="margin-right:10px">View demo</a> or <a  style="margin-left:10px;" href="http://apps.pharmerit.com/cea/">Download HTML</a>
        </div>
      </div>
      <div class="card cardShadow p-2 mb-4 pCard slide-left3">
        <div class="card-body">
          <h3 class="card-title">Enhanced Excel GUIs</h3>
          <p class="card-text">Description here.</p>
          <a href="#" class="btn btn-primary">In progress...</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Landing",
  components: {},
  data() {
    return {
      title: "Landing"
    };
  }
};
</script>

<style lang="scss">
@import "../scss/bootstrap-custom.scss";
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
</style>


// WEBPACK FOOTER //
// src/views/Landing.vue